import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { AuthService } from "../services/auth.service";
import { Observable } from "rxjs";
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const authToken = this.authService.getToken();

        // Cookies from cross-origin APIs require withCredentials=true.
        const requestConfig: { withCredentials: boolean; setHeaders?: { Authorization: string } } = {
            withCredentials: true
        };

        if (authToken) {
            requestConfig.setHeaders = {
                Authorization: "Bearer " + authToken,
            };
        }

        req = req.clone(requestConfig);
        return next.handle(req);
    }
}